<template>
  <div class="banner-box">
    <!-- swiper :options="swiperOption" @slideChange="slideChange" ref="bannerSwiper">
      <swiper-slide v-for="(item, index) in bannerList" :key="`banner${index}`">
        <outboxCon :bg="curBg">
          <div class="home-banner">
            <bannerTwo :vm="item" ></bannerTwo>
          </div>
        </outboxCon>
      </swiper-slide>
    </swiper >
    <div class="swiper-pagination"></div-->
    <bannerTwo :vm="bannerList[0]" ></bannerTwo>
  </div>
</template>
<script>
import bannerTwo from './banner-two'
export default {
  data () {
    return {
      bannerList: [
        {
          isJson: false,
          logoImg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/logo-tal.png',
          jsonData: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-2.png',
          message: '北京世纪好未来教育科技有限公司（NYSE：TAL），中国教育行业龙头企业，致力于“用科技推动教育进步”，用爱和科技让教育更美好'
        },
        {
          isJson: true,
          logoImg: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/title-logo.png',
          jsonData: require('@/../public/lottie/data.json'),
          message: '好未来旗下K12校外培训机构服务平台；18年教学教研沉淀，千所校区运营成功经验，为全国教育企业提供高品质教学产品及办学解决方案，助力合作伙伴把优质教育资源共享给更多孩子'
        }

      ],
      swiperOption: {
        notNextTick: true,
        direction: 'horizontal',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        speed: 1000,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      current: 0,
      curBg: '#00205E',
      bgList: ['#00205E', '#2b4ab6']
    }
  },
  components: { bannerTwo },
  methods: {
    slideChange () {
      this.current = this.$refs.bannerSwiper.swiper.realIndex
      this.curBg = this.bgList[this.current]
    },
    stopSwiper () {
      this.$refs.bannerSwiper.swiper.autoplay.stop()
    },
    startSwiper () {
      this.$refs.bannerSwiper.swiper.autoplay.start()
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-box{
  position: relative;
  .home-banner{
      width: $main-width;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      color: #2b4ab6;
  }
  ::v-deep .swiper-pagination-bullets{
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    .swiper-pagination-bullet{
      width:6px;
      height:6px;
      background:rgba(255,255,255,1);
      border-radius:3px;
      margin-right: 5px;
      opacity: 1;
      outline: none;
      &.swiper-pagination-bullet-active{
        width:30px;
        height:6px;
        background:rgba(255,255,255,0.5);
        border-radius:3px;
        outline: none;
      }
    }
  }
}
</style>
